import { createProgressMessage } from 'src/utils/voicebox/messages';

export const INITIAL_EXISTING_MODEL_PROGRESS_MESSAGE = createProgressMessage({
  content: `
Hi! I'm Voicebox and I am here to help you edit an existing data model for your Knowledge Graph!
Simply describe the changes you wish to make to your data model.
`.trim(),
});

export const createExistingModelPrompt = ({
  userPrompt,
}: {
  userPrompt: string;
}) => {
  return (
    `Please provide a Stardog Data Model, without any other explanation or information that was not requested, ` +
    `serialized as Turtle code, that uses the above schema, that answers the following question: ${userPrompt}.`
  );
};
